import React from 'react';
import Icon from '../../../components/AppIcon';
import AppImage from '../../../components/AppImage';

const BookingSummaryCard = ({ bookingData }) => {
  return (
    <div className="rounded-2xl p-6" style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(0,212,255,0.15)' }}>
      <h2 className="text-lg font-bold text-white mb-5 flex items-center gap-2">
        <Icon name="FileText" size={20} color="#00D4FF" />
        Booking Summary
      </h2>

      {/* Professional Info */}
      <div className="flex items-center gap-4 mb-5 pb-5" style={{ borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0" style={{ border: '2px solid rgba(0,212,255,0.3)' }}>
          <AppImage
            src={bookingData?.professionalPhoto}
            alt={`Profile photo of ${bookingData?.professionalName}`}
            className="w-full h-full object-cover"
          />
        </div>
        <div>
          <p className="text-base font-bold text-white">{bookingData?.professionalName}</p>
          <p className="text-sm" style={{ color: '#00D4FF' }}>{bookingData?.professionalCategory}</p>
          <p className="text-xs" style={{ color: '#6B9EC4' }}>{bookingData?.professionalCompany}</p>
        </div>
      </div>

      {/* Booking Details Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="rounded-xl p-4" style={{ background: 'rgba(0,212,255,0.05)', border: '1px solid rgba(0,212,255,0.1)' }}>
          <p className="text-xs font-medium mb-1" style={{ color: '#6B9EC4' }}>Service Type</p>
          <p className="text-sm font-semibold text-white">{bookingData?.serviceType}</p>
        </div>
        <div className="rounded-xl p-4" style={{ background: 'rgba(0,212,255,0.05)', border: '1px solid rgba(0,212,255,0.1)' }}>
          <p className="text-xs font-medium mb-1" style={{ color: '#6B9EC4' }}>Preferred Date</p>
          <p className="text-sm font-semibold text-white">{bookingData?.preferredDate || 'Flexible'}</p>
        </div>
        <div className="rounded-xl p-4" style={{ background: 'rgba(0,212,255,0.05)', border: '1px solid rgba(0,212,255,0.1)' }}>
          <p className="text-xs font-medium mb-1" style={{ color: '#6B9EC4' }}>Preferred Time</p>
          <p className="text-sm font-semibold text-white">{bookingData?.preferredTime || 'To be confirmed'}</p>
        </div>
        <div className="rounded-xl p-4" style={{ background: 'rgba(0,212,255,0.05)', border: '1px solid rgba(0,212,255,0.1)' }}>
          <p className="text-xs font-medium mb-1" style={{ color: '#6B9EC4' }}>Client Name</p>
          <p className="text-sm font-semibold text-white">{bookingData?.clientName}</p>
        </div>
      </div>

      {/* Booking Reference */}
      <div className="mt-5 rounded-xl p-4 text-center" style={{ background: 'rgba(0,255,136,0.05)', border: '1px solid rgba(0,255,136,0.2)' }}>
        <p className="text-xs font-medium mb-1" style={{ color: '#6B9EC4' }}>Booking Reference Number</p>
        <p className="text-xl font-bold tracking-widest" style={{ color: '#00FF88' }}>{bookingData?.referenceNumber}</p>
        <p className="text-xs mt-1" style={{ color: '#6B9EC4' }}>Save this number for your records</p>
      </div>
    </div>
  );
};

export default BookingSummaryCard;
